import http from "../../http-common";

// COLOPLAST
const getPrintQueryColoplast = (data) => { return http.post("/PrintQuery/FilterPrintQueryColoplast", data); };
const updatePrintQueryColoplast = (data) => { return http.post("/PrintQuery/UpdatePrintingColoplast", data); };

// UFI
const getPrintQueryUfi = (data) => { return http.post("/PrintQuery/FilterPrintQueryUfi", data); };
const updatePrintQueryUfi = (data) => { return http.post("/PrintQuery/UpdatePrintingUfi", data); };

// MOTUL
const getPrintQueryMotul = (data) => { return http.post("/PrintQuery/FilterPrintQueryMotul", data); };
const updatePrintQueryMotul = (data) => { return http.post("/PrintQuery/UpdatePrintingMotul", data); };

// GENERIC
const getPrintQueryGeneric = (data) => { return http.post("/PrintQuery/FilterPrintQueryGeneric", data); };
const updatePrintQueryGeneric = (data) => { return http.post("/PrintQuery/UpdatePrintingGeneric", data); };

export default {
    getPrintQueryColoplast,
    updatePrintQueryColoplast,
    getPrintQueryUfi,
    updatePrintQueryUfi,
    getPrintQueryMotul,
    updatePrintQueryMotul,
    getPrintQueryGeneric,
    updatePrintQueryGeneric
};
